module.exports = __webpack_public_path__ + "static/product-01b735a15152984f9c5338de71d84777.png";